module.exports = __webpack_public_path__ + "img/pre_20211001_8pll.4f46a813.png";